import { render, staticRenderFns } from "./setType6Template.vue?vue&type=template&id=249f18b6&scoped=true"
import script from "./setType6Template.vue?vue&type=script&lang=js"
export * from "./setType6Template.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "249f18b6",
  null
  
)

export default component.exports